exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UGCYDTENW-4_M3{padding:0 12px}.UGCYDTENW-4_M3 .uu86xHdq3PUNus{width:100%;margin-bottom:8px}._1k3u8dcz6MM0wO{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"createTeam": "UGCYDTENW-4_M3",
	"createTeamInput": "uu86xHdq3PUNus",
	"createTeamButton": "_1k3u8dcz6MM0wO"
};